'use client';

import { createContext, type ReactNode, useContext, useMemo } from 'react';

import { useViewMode, type ViewMode } from '@/src/lib/hooks/ui/useViewMode';

type ViewModeContextValue = {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
};

const ViewModeContext = createContext<ViewModeContextValue | null>(null);

export function SearchViewModeProvider({ children }: { children: ReactNode }) {
  const [viewMode, setViewMode] = useViewMode();
  const value = useMemo(() => ({ viewMode, setViewMode }), [viewMode, setViewMode]);
  return <ViewModeContext.Provider value={value}>{children}</ViewModeContext.Provider>;
}

export function useSrpViewMode(): ViewModeContextValue {
  const ctx = useContext(ViewModeContext);
  if (!ctx) {
    return { viewMode: 'grid', setViewMode: () => {} };
  }
  return ctx;
}
